module.exports = __webpack_public_path__ + "61783558cf96f031866a6a0acc4c2847.woff";